var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contact contact-phone",class:("contact-phone-" + _vm.style_class)},[_c('phone-call-icon',{attrs:{"size":"1x"}}),_c('span',[_vm._v("+38 093 766 34 64")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }